{
    "commonTitles": {
        "warning": "Попередження",
        "confirmation": "Підтвердження"
    },
    "cancelOrder": {
        "alertMsg": "Ви дійсно хочете скасувати замовлення?"
    },
    "editOrderSuccess": {
        "title": "Дякуємо!",
        "messageLine1": "Ваш запит на внесення змін відправлено адміністратору.",
        "messageLine2": "Ми повідомимо вас про результат на email.",
        "understoodBtn": "Зрозуміло"
    },
    "documents": {
        "upload": {
            "title": "Завантажити документ",
            "file": "Файл",
            "fileRequired": "Будь ласка, виберіть файл для завантаження",
            "fileSizeError": "Розмір файлу перевищує ліміт 10МБ",
            "selectedFile": "Вибраний файл",
            "orderNumber": "Номер замовлення",
            "selectOrder": "Виберіть замовлення",
            "type": "Тип документа",
            "typePlaceholder": "Введіть тип документа",
            "documentNumber": "Номер документа",
            "documentNumberPlaceholder": "Введіть номер документа",
            "documentDate": "Дата документа",
            "description": "Опис",
            "descriptionPlaceholder": "Введіть опис",
            "comment": "Коментар",
            "commentPlaceholder": "Введіть коментар"
        },
        "delete": {
            "alertMsg": "Ви впевнені, що хочете назавжди видалити цей документ?",
            "fileName": "Назва файлу"
        }
    },
    "invoices": {
        "upload": {
            "title": "Завантажити рахунок",
            "file": "Файл",
            "fileRequired": "Будь ласка, виберіть файл для завантаження",
            "fileSizeError": "Розмір файлу перевищує ліміт 10МБ",
            "selectedFile": "Вибраний файл",
            "orderNumber": "Номер замовлення",
            "selectOrder": "Виберіть замовлення",
            "recipientCompany": "Компанія-отримувач",
            "selectCompany": "Виберіть компанію",
            "invoiceNumber": "Номер рахунку",
            "invoiceNumberPlaceholder": "Введіть номер рахунку",
            "type": "Тип рахунку",
            "typePlaceholder": "Введіть тип рахунку",
            "seller": "Продавець",
            "sellerPlaceholder": "Введіть назву продавця",
            "invoiceDate": "Дата рахунку",
            "dueDate": "Термін оплати",
            "dueDateAfterInvoiceDate": "Термін оплати повинен бути після дати рахунку",
            "currency": "Валюта",
            "amount": "Сума",
            "amountPaid": "Сплачено",
            "amountPaidExceedsAmount": "Сплачена сума не може перевищувати загальну суму",
            "status": "Статус",
            "description": "Опис",
            "descriptionPlaceholder": "Введіть опис",
            "comment": "Коментар",
            "commentPlaceholder": "Введіть коментар"
        },
        "delete": {
            "alertMsg": "Ви впевнені, що хочете назавжди видалити цей рахунок?",
            "invoiceNumber": "Номер рахунку"
        }
    },
    "individualTariffRequest": {
        "title": "Запит прямого тарифу",
        "alertMsg": "На жаль, для вашого запиту немає доступних тарифів. Залиште свої контактні дані, і ми зв'яжемося з вами, щоб запропонувати індивідуальне рішення",
        "deliveryTypeLbl": "Тип доставки",
        "shippingTimeLbl": "Термін доставки",
        "loadingDateLbl": "Дата завантаження",
        "deliveryDateLbl": "Дата доставки"
    },
    "addAddress": {
        "addTitle": "Додати новий контакт",
        "editTitle": "Редагувати контакт"
    },
    "deleteAddress": {
        "alertMsg": "Ви впевнені що хочете видалити контакт з адресної книги безповоротньо?"
    },
    "company": {
        "addTitle": "Додати компанію",
        "editTitle": "Редагувати компанію",
        "deleteAlertMsg": "Ви впевнені, що хочете видалити компанію \"{{companyName}}\" безповоротньо?"
    }
}